import { Box, Typography } from '@mui/material';
import { useMemo } from 'react';

export const useTitleValue = (
  isLabel: boolean,
  length: number,
  optional?: boolean
) => {
  return useMemo(() => {
    const baseText = `Add/Create ${isLabel ? 'Label' : 'List'}`;

    if (optional) {
      return (
        <Box>
          {baseText}{' '}
          <Typography variant="body4" color="grey.500" component="span">
            (Optional)
          </Typography>
        </Box>
      );
    }

    return baseText;
  }, [isLabel, length, optional]);
};
